import { Component, OnInit, input } from '@angular/core';
import QRious from './qrious.min.js'; // https://github.com/neocotic/qrious

export interface QrCodeConfig {
  background?: string,
  backgroundAlpha?: number,
  foreground?: string,
  foregroundAlpha?: number,
  padding?: number,
  size?: number,
};

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss'],
})
export class QrCodeStandaloneComponent implements OnInit {

  private _defaultConfig: QrCodeConfig = {
    background: '#fff',
    backgroundAlpha: 1,
    foreground: '#000',
    foregroundAlpha: 1,
    padding: 20,
    size: 200,
  };

  public imgBase: string = null;

  readonly link = input<string>(undefined);
  readonly config = input<QrCodeConfig>({});

  constructor() {
  }

  ngOnInit(): void {
    const qr = new QRious({
      value: this.link(),
      ...{...this._defaultConfig, ...this.config()}
    });
    this.imgBase = qr.toDataURL();
  }
}
